import React, { useEffect, useMemo, useState } from "react";
import {
  PROFILE_PLACEHOLDER_IMAGE,
  resolveProfileImageSrc,
} from "utils/profileImage";
import "./ProfileAvatar.css";

const ProfileAvatar = ({
  baseUrl = "",
  profilePicture = "",
  preview = "",
  className = "",
  variant = "default",
  style = {},
  width,
  height,
  alt = "",
  ...rest
}) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [baseUrl, profilePicture, preview]);

  const src = useMemo(
    () =>
      resolveProfileImageSrc({
        baseUrl,
        profilePicture: failed ? "" : profilePicture,
        preview,
      }),
    [baseUrl, failed, preview, profilePicture],
  );

  const isPlaceholder =
    !preview &&
    (failed || !profilePicture || src === PROFILE_PLACEHOLDER_IMAGE);

  const shellClasses = [
    "profile-avatar-shell",
    `profile-avatar-shell--${variant}`,
    isPlaceholder
      ? "profile-avatar-shell--placeholder"
      : "profile-avatar-shell--photo",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const imageClasses = [
    "profile-avatar-shell__image",
    isPlaceholder
      ? "profile-avatar-shell__image--placeholder"
      : "profile-avatar-shell__image--photo",
  ].join(" ");

  return (
    <span
      className={shellClasses}
      style={{
        ...(width ? { width, height: height || width } : {}),
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        className={imageClasses}
        onError={() => setFailed(true)}
        {...rest}
      />
    </span>
  );
};

export default ProfileAvatar;
